import { useState } from "react";
import { Loader2, Check } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterForm({ source = "footer", testIdPrefix = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await api.post("/newsletter", { email, source });
      setSuccess(true);
      setEmail("");
      toast.success("You are now on the AlchamisGroup briefing list.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  }

  if (success) {
    return (
      <div className="flex items-center gap-2 text-gold text-sm" data-testid={`${testIdPrefix}-success`}>
        <Check size={14} /> You will receive our next briefing.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex items-center gap-2" data-testid={`${testIdPrefix}-form`}>
      <input
        required
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testIdPrefix}-input`}
        className="bg-[#FAFAF6] border border-[#001B54]/10 focus:border-gold/50 outline-none px-3.5 py-2.5 text-sm text-[#001B54] placeholder:text-[#6B7390] w-full max-w-[280px]"
      />
      <button
        type="submit"
        disabled={sending}
        data-testid={`${testIdPrefix}-submit`}
        className="px-4 py-2.5 bg-gold text-navy text-[0.7rem] tracking-[0.18em] uppercase font-medium hover:bg-gold-pale transition-colors disabled:opacity-50"
      >
        {sending ? <Loader2 size={14} className="animate-spin" /> : "Subscribe"}
      </button>
    </form>
  );
}
